import { render, staticRenderFns } from "./TicketFormV1.vue?vue&type=template&id=1dd83134&scoped=true&"
import script from "./TicketFormV1.vue?vue&type=script&lang=js&"
export * from "./TicketFormV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd83134",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dd83134')) {
      api.createRecord('1dd83134', component.options)
    } else {
      api.reload('1dd83134', component.options)
    }
    module.hot.accept("./TicketFormV1.vue?vue&type=template&id=1dd83134&scoped=true&", function () {
      api.rerender('1dd83134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/TicketFormV1.vue"
export default component.exports